//# sourceMappingURL=custom-table-layout.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/pdfmake-wrapper/lib/interfaces/table/custom-table-layout.interface.js
// module id = 1186
// module chunks = 4